var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"frontPage"}},[_c('p',{attrs:{"id":"slogan"}},[_vm._v("Dedicated to helping get your project off the ground")]),_vm._v(" "),_c('div',{attrs:{"id":"globe"}},[_c('video',{attrs:{"autoplay":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require('@/assets/CloseUpGlobeSpin.mp4'),"type":"video/mp4"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b84aa22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/FrontPage.vue
// module id = null
// module chunks = 